var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$matchMedia.m)?_c('Desktop',{attrs:{"points":_vm.points}}):_c('Mobile',{attrs:{"points":_vm.points}})
}
var staticRenderFns = []

export { render, staticRenderFns }